import React from 'react';
import { Stack, Skeleton } from '@mui/material';
import styles from './NotificationsWidget.module.scss';

export const NotificationItemSkeleton: React.FC = () => {
  return (
    <Stack direction="row" gap="16px" className={styles.notificationItem}>
      <Skeleton variant="circular" width={32} height={32} />
      <Stack flex={1} gap="8px">
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="text" width="100px" height={16} />
      </Stack>
    </Stack>
  );
};
